// packages/storefront/src/hooks/useContactRequestProtection.ts
import { useEffect, useMemo } from 'react';
import { createContactRequestProofClient, type ContactRequestProofClient } from '../api/contactRequestProtection';

export function useContactRequestProtection(bizIdOrSlug: string, bizToken: string, active = true): ContactRequestProofClient {
  const client: ContactRequestProofClient = useMemo(() => createContactRequestProofClient(bizIdOrSlug, bizToken), [bizIdOrSlug, bizToken]);
  useEffect(() => { if (active) void client.prepare(); }, [client, active]);
  return client;
}
